import bridge from "@vkontakte/vk-bridge";

const bridgeGetUserInfo = () => {
 return bridge.send('VKWebAppGetUserInfo')
}

export default bridgeGetUserInfo